export default __webpack_public_path__ + "static/media/pitch-bn.14a0fe37.png";